export default __webpack_public_path__ + "static/media/call-announcement.c679b23d.mp3";